import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { obterConfiguracao } from '@/config/runtime';
const ContextoDaSessao = createContext(null);
export function SessaoProvider({ children }) {
    const sessao = useMemo(() => ({ token: obterConfiguracao().apiToken }), []);
    return _jsx(ContextoDaSessao.Provider, { value: sessao, children: children });
}
export function useSessao() {
    const sessao = useContext(ContextoDaSessao);
    if (sessao === null) {
        throw new Error('useSessao exige SessaoProvider acima na árvore');
    }
    return sessao;
}
